let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e2aED")).then(() => parcelRequire('8h9io'));